import HandleRequest from "./HandleRequest";

const { getRequest, postRequest, patchRequest, deleteRequest } =
  HandleRequest();
export default function UserService() {
  return {
    create: async (data: object) => postRequest("/api/v1/user", data),
    get: async (id: string) => getRequest(`/api/v1/user/${id}`),
    update: async (id: string, data: object) =>
      patchRequest(`/api/v1/user/${id}`, data),
    delete: async (id: string) => deleteRequest(`/api/v1/user/${id}`),
    auth: async (data: object) => postRequest("/api/login", data),
  };
}
